import { action } from "satcheljs";
import type { BizChatSidePaneRenderMode } from "owa-bizchat-types";

export interface OnBizChatReadyMessage {
    /* The render mode (SSR or CSR) reported by BizChat when the chat became ready. */
    renderMode: BizChatSidePaneRenderMode;
    /* The window hosting the BizChat instance that became ready. */
    targetWindow: Window;
    /* Whether the ready BizChat instance is the immersive (full-screen) experience. */
    isImmersiveBizchat?: boolean;
}

export const onBizChatReady: (renderMode: BizChatSidePaneRenderMode, targetWindow: Window, isImmersiveBizchat?: boolean) => OnBizChatReadyMessage = action("onBizChatReady", (renderMode: BizChatSidePaneRenderMode, targetWindow: Window, isImmersiveBizchat?: boolean): OnBizChatReadyMessage => ({
    renderMode,
    targetWindow,
    isImmersiveBizchat,
}));
